// src/components/ProductPage.tsx
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { products, Product } from '../data/products';
import PurchaseLink from './PurchaseLink'; // Ensure the path is correct
import { isExcelAfterDark, siteConfig } from '../config/site';

export const ProductPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const [product, setProduct] = useState<Product | null>(null);

  useEffect(() => {
    console.log('Received slug:', slug);
    if (slug && products[slug]) {
      console.log('Product found:', products[slug]);
      setProduct(products[slug]);
    } else {
      console.log('Product not found for slug:', slug);
      setProduct(null);
    }
  }, [slug]);

  if (!product) {
    return <div className="text-center py-16">Product not found</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Product Image */}
          <div>
            <img 
              src={product.image} 
              alt={product.title} 
              className="w-full rounded-xl shadow-lg"
            />
          </div>
          {/* Product Details */}
          <div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">{product.title}</h1>
            <p className="text-xl text-gray-600 mb-6">{product.description}</p>
            <div className="mb-8">
              <span className={`text-3xl font-bold ${siteConfig.theme.accentText}`}>{product.price}</span>
            </div>
            {/* Key Features */}
            <div className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Key Features</h2>
              <ul className="space-y-3">
                {product.features.map((feature, index) => (
                  <li key={index} className="flex items-center">
                    {/* Checkmark Icon */}
                    <svg className={`h-5 w-5 ${siteConfig.theme.icon} mr-3`} fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path d="M5 13l4 4L19 7"></path>
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
            {/* Dynamic PurchaseLink Component */}
            <PurchaseLink priceId={product.priceId} productSlug={product.slug} />
          </div>
        </div>
        {/* More Products Section */}
        {!isExcelAfterDark && <div className="mt-24">
          <h2 className="text-3xl font-bold mb-8">More Excel Add-ins</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Object.entries(products)
              .filter(([key]) => key !== slug) // Exclude current product
              .map(([key, product]) => (
                <Link 
                  key={key} 
                  to={`/products/${key}`}
                  className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow"
                >
                  <img src={product.image} alt={product.title} className="w-full h-48 object-cover" />
                  <div className="p-6">
                    <h3 className="text-xl font-semibold mb-2">{product.title}</h3>
                    <p className="text-gray-600 mb-4">{product.description}</p>
                    <span className="text-2xl font-bold text-green-600">{product.price}</span>
                  </div>
                </Link>
              ))}
          </div>
        </div>}
      </div>
    </div>
  );
};
